import AddPin from "./AddPin.png";

export default AddPin;
